export default JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: 'https://www.nykaafashion.com/',
  potentialAction: [
    {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://www.nykaafashion.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  ],
});
